import React from 'react';
import { useLocation } from "react-router-dom";
import { NavbarBrand, Nav } from 'reactstrap';
import { BsFacebook, BsInstagram, BsEnvelope, BsWhatsapp } from 'react-icons/bs';

import MainSearchForm from '../MainSearch/MainSearchForm';
import { LoginNavItem, LoginNavItemMobile } from './CustomLoginNavItem/LoginNavItem';
import Menu from './Menu';

import './Header.scss';
import './HeaderSearch.scss';

import logoFull from '../../assets/img/TuHogarOnline.png';
import logo from '../../assets/img/TuHogarOnline-circle.png';

const SearchTopHeader = () => (
  <>
    <section className="header__top container d-none d-md-flex justify-content-end position-absolute">
      <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.facebook.com/tuhogaronline.com.ar/"><BsFacebook /></a>
      <a title="Seguinos..." className="d-none d-md-block header__link" target="_blank" href="https://www.instagram.com/tu_hogar_online/"><BsInstagram /></a>
      <a title="Consúltanos..." className="d-none d-md-block header__link" target="_blank" href="https://api.whatsapp.com/send?phone=542915111792&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20"><BsWhatsapp /></a>
      <a title="Consúltanos..." className="d-none d-md-block header__link mr-3" target="_blank" href="mailto:tuhogaronline@gmail.com"><BsEnvelope /></a>

      <div className="header__loguin">
        <Nav>
          <LoginNavItem closeHeader={false} />
        </Nav>
      </div>
    </section>
    <div className="container headerSearch__brand d-flex flex-column flex-md-row justify-content-around">
      <NavbarBrand href="/">
        <img className="img-fluid" src={logoFull} alt="Tu Hogar Online" />
        <img className="img-fluid" src={logo} alt="Tu Hogar Online" />
      </NavbarBrand>
      <MainSearchForm />
    </div>
  </>
)

const TopHeader = () => (
  <React.Fragment>
    <section className="header__top container d-none d-md-flex justify-content-end position-absolute">

      <div className="header__loguin">
        <Nav>
          <LoginNavItem closeHeader={false} />
        </Nav>
      </div>
    </section>
    <NavbarBrand href="https://www.tuhogaronline.com.ar/">
      <img className="img-fluid" src={logo} alt="Tu Hogar Online" />
    </NavbarBrand>
  </React.Fragment>
)

const Header = (props) => {

  const { pathname } = useLocation();
  const isRoot = pathname === "/";

  return (
    <header className="headerSearch">
      <SearchTopHeader />
      <Menu />
    </header>
  );
};

export default Header;
